import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MicIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path fill="currentColor" d="M5 4a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0V4Z"></path>
		<path
			fill="currentColor"
			d="M3.5 5.5A.5.5 0 0 1 4 6v2.5A3.5 3.5 0 0 0 7.5 12h1A3.5 3.5 0 0 0 12 8.5V6a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4 4.473V14a1 1 0 0 1 1 1H6a1 1 0 0 1 1-1v-1.027A4.5 4.5 0 0 1 3 8.5V6a.5.5 0 0 1 .5-.5Z"
		></path>
	</svg>
))
